import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaHamburger } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-[#39160d] text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-xl font-bold">
          <img width={50} src="/suwasthi-logo-white.png" />
        </div>
        <nav className="hidden md:block">
          <Link to="/tracking" className="bg-white text-[#39160d] hover:bg-blue-100 py-2 px-4 w-full p-3 rounded-md text-md transition">
            Track Your Application
          </Link>
        </nav>
        {isMenuOpen === false ? (
          <GiHamburgerMenu
            onClick={toggleMenu}
            className="cursor-pointer md:hidden"
            height={30}
          />
        ) : (
          <CgClose
            onClick={toggleMenu}
            className="cursor-pointer md:hidden"
            height={30}
          />
        )}
      </div>
      {isMenuOpen && (
        <div className="md:hidden text-center mt-5">
          <Link to="/tracking" className="bg-white text-[#39160d] hover:bg-blue-100 py-2 px-4 w-full p-3 rounded-md text-md transition">
            Track Your Application
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;